import FetchData from '@v4/common/components/atoms/FetchData/FetchData';

export default FetchData;
